export enum AppScreen {
    Loading = 'loading',
    Welcome = 'welcome',
    Upload = 'upload',
    HomeLocation = 'home-location',
    SelectTimePeriod = 'select-time-period',
    Map = 'map',
    WrapUp = 'wrap-up',
    Discover = 'discover',
    BigYear = 'big-year',
    FamilyExplorer = 'family-explorer'
}
